export default __webpack_public_path__ + "static/media/icon_bot_white.fdaf4dc9.svg";